import React from 'react';
import {
  SimpleSelect,
  Row,
  Col,
  ButtonIcon
} from '@youngcapital/component-library';
import { FIELDSET_PROPTYPES } from '../asFieldset';

const generateOptions = (optionsArray, nameKey) =>
  optionsArray.map(option => (
    <option key={option.id} id={option.id} value={option.id}>
      {option[nameKey]}
    </option>
  ));

const EducationEntry = ({
  getFieldProps,
  index,
  isOnlyField,
  optionsData,
  removeEducation,
  t
}) => {
  const getKey = prop => `degrees[${index}].${prop}`;
  const isNotFirst = index > 0;
  const degreesOptions = optionsData.degrees_options || [];

  return (
    <>
      {!isOnlyField && (
        <>
          {isNotFirst && <hr className='mb-0' />}
          <Row>
            <Col xs={12}>
              <div className='end-xs'>
                <ButtonIcon
                  onClick={removeEducation}
                  id={`${index}`}
                  iconVariant='close-cross'
                  data-cy='remove_education_entry'
                  title='remove-education-button'
                />
              </div>
            </Col>
          </Row>
        </>
      )}
      <SimpleSelect
        label={t('fieldset_education.type_label')}
        placeholder={t('fieldset_education.type_placeholder')}
        {...getFieldProps(getKey('edu_type_id'), props => ({
          ...props,
          onChange: e => {
            const { value } = e.target;
            props.setValue(value);
          }
        }))}
        isRequired
      >
        {generateOptions(degreesOptions, 'name')}
      </SimpleSelect>
    </>
  );
};

EducationEntry.type = 'education';

EducationEntry.propTypes = FIELDSET_PROPTYPES;

export default EducationEntry;
